import { render, staticRenderFns } from "./salarypay-detail.vue?vue&type=template&id=89730af0&scoped=true&"
import script from "./salarypay-detail.vue?vue&type=script&lang=js&"
export * from "./salarypay-detail.vue?vue&type=script&lang=js&"
import style0 from "./salarypay-detail.vue?vue&type=style&index=0&id=89730af0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89730af0",
  null
  
)

export default component.exports